
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { UserDetailsActions } from "../actions/table_actions";
import { mandantendetails, userdetails } from "../typing/types";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";
import { loginActions } from "../../Login/actions/LoginAction";
import { renewedToken } from "../../Login/typing/renewed_token_logic";
import { message } from "antd";


interface testdataResponsePayloadInterface{
    data:{
    user:userdetails[],
    }
}

interface userUpdateResponsePayloadInterface{
    save:string,
    /** Set when one's own password changed (anima_core#24). */
    token?:string
}

interface userMandantenResponsePayloadInterface{
        data:mandantendetails[],
}

export const requestDataFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/"+uuid.toString(),
            {},
            "GET",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload)
                dispatch(
                    UserDetailsActions.resetData(
                         {
                             data : payload.data.user[0],
                         }
                     )
                 );
            },
            ()=>{}
        ) as any)
    }
}




export const requestClientToogle =(uuid:string, useruuid:string, action:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/Mandant/"+useruuid+"/"+uuid+"/"+action,
            {},
            "PUT",
            (payload:userUpdateResponsePayloadInterface) => {
                console.log(payload)               
                message.success(payload.save);
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                message.error(payload.save);
                
            },
        ) as any)
    }
}

export const requestUserNotCLientListFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/Mandant/"+uuid+"/"+uuid+"/getnot",
            {},
            "PUT",
            (payload:userMandantenResponsePayloadInterface) => {
                console.log(payload)
                if (payload.data.length > 0)
                {
                dispatch(
                    UserDetailsActions.resetnotmandData(
                         {
                             data : payload.data,
                         }
                     )
                 );
                }
                else
                {
                    dispatch(
                        UserDetailsActions.resetnotmandData(
                             {
                                 data : [] as mandantendetails[],
                             }
                         )
                     );
                }
                
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                message.error(payload.save);
                
            },
        ) as any)
    }
}

export const requestUserCLientListFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        console.log(masteruri+"/Users/Mandant/"+uuid+"/"+uuid+"/get");
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/Mandant/"+uuid+"/"+uuid+"/get",
            {},
            "PUT",
            (payload:userMandantenResponsePayloadInterface) => {
                console.log(payload)
                if (payload.data.length > 0)
                {
                dispatch(
                    UserDetailsActions.resetincmandData(
                         {
                             data : payload.data,
                         }
                     )
                 );
                        }
                        else
                {
                    dispatch(
                        UserDetailsActions.resetincmandData(
                             {
                                 data : [] as mandantendetails[],
                             }
                         )
                     );
                }
                
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                message.error(payload.save);
                
            },
        ) as any)
    }
}

export const requestUserUpdateFromAPI =(data:any, uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log("SEND");
        console.log(data);
        console.log(masteruri+"/Users/"+uuid);
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users/"+uuid,
            {data},
            "PUT",
            (payload:userUpdateResponsePayloadInterface) => {
                console.log(payload.save)
                // One's own password changed: every session of the account
                // ended, this one goes on with the renewed token
                // (anima_core#24) - before the next request.
                const token = renewedToken(payload);
                if (token !== null) {
                    dispatch(loginActions.renewToken({ token }));
                }
                message.success(payload.save);
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                message.error(payload.save);
                
            },
        ) as any)
    }
}

